module.exports = __webpack_public_path__ + "static/media/guangtoushan_package.2afc1620.png";